import * as React from 'react';
import { StyleSheet, TouchableOpacity, Image } from 'react-native';
import * as Handlers from './handle';
import * as Constants from './constant';
import theme, { Icon, Colors } from '@qnpm/q-theme';
import { qAccessibilityLabel } from '@qnpm/q-design-utils';
const { responsive: { scale } } = theme;
const { scenes: { radioBoxColors } } = Colors;
const defaultSize = { width: 20, height: 20 };
export class RadioBox extends React.Component {
    render() {
        return this.renderRadioButton();
    }
    /**
     * RadioButton单选
     */
    renderRadioButton() {
        const { disable = false, size = defaultSize, type = 'base', selected, needScale = false, accessibilityPreName = '' } = this.props;
        const style = {
            width: scale(size.width, needScale),
            height: scale(size.height, needScale)
        };
        const marginStyle = Handlers.getComponentMargin(this.props.customStyle);
        const { wrapper } = Handlers.getComponentStyle(this.props);
        return (<TouchableOpacity {...qAccessibilityLabel(`${accessibilityPreName}qdRadioBox#${selected}#${disable}`)} activeOpacity={disable ? 1 : 0.8} onPress={this.clickRadio.bind(this)} style={[styles.wrapper, wrapper, style, marginStyle]}>
                {type === 'base'
            ? this.renderFontIcon(selected)
            : this.renderImgIcon()}
            </TouchableOpacity>);
    }
    /**
     * Iconfont
     * @param selected 是否选中
     */
    renderFontIcon(selected) {
        if (!selected) {
            return null;
        }
        const fontSize = this.getIconFontSize();
        return (<Icon size={fontSize} name="checked" color={radioBoxColors.icon} needScale={this.props.needScale}/>);
    }
    /**
     * 图片icon
     */
    renderImgIcon() {
        const { disable = false, selected = false } = this.props;
        const selectUrl = selected
            ? Constants.ICON_IMG.selected
            : Constants.ICON_IMG.unselected;
        const url = disable ? Constants.ICON_IMG.unavailable : selectUrl;
        return <Image style={styles.imgIcon} source={{ uri: url }}/>;
    }
    /**
     * 获取字体大小，如果外部未传值，则取size的宽和高的最小值
     */
    getIconFontSize() {
        const { fontSize, size = defaultSize } = this.props;
        if (!fontSize) {
            return Math.min(size.width, size.height);
        }
        if (typeof fontSize === 'string') {
            return parseInt(fontSize, 20);
        }
        return fontSize;
    }
    /**
     * 点击单选框
     */
    clickRadio() {
        const { onPress, disable = false, selected = false, type = 'base' } = this.props;
        if (disable && type === 'radio') {
            return;
        }
        onPress && onPress(selected);
    }
}
const styles = StyleSheet.create({
    wrapper: {
        justifyContent: 'center',
        alignItems: 'center'
    },
    imgIcon: {
        width: '100%',
        height: '100%'
    }
});
